import React, { useState, useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { userValidate } from "~/api/getUser";
import axios from "@dreamchimney/react-axios";
import { LOCAL_STORE_JWT } from "~/utils/main";
import { useUser } from "~/Context/userContext";

const Auth = (props) => {
  const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;
  const [loading, setLoading] = useState(true);
  const { dispatch } = useUser();

  const loadDataOnlyOnce = async () => {
    // still using php validate
    await userValidate(axios, { jwt })
      .then(({ data }) => {
        if (!data.success) {
          // @TODO this makes the jwt was not set or invalid
          // should redirect user to re-auth page
          throw new Error("User not validated");
        }
        return data;
      })
      .then(({ isChim, user }) => {
        const dispatchType = isChim === false ? "user_login" : "login";
        dispatch({ type: dispatchType, payload: { user } });
        return;
      })
      .then(() => setLoading(false))
      .catch((e) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (jwt) {
      loadDataOnlyOnce();
    } else {
      setLoading(false);
      dispatch({ type: "anonymous", payload: {} });
    }
  }, []);

  if (loading) {
    return <Spinner animation="border" style={{ display: "block", float: "right", marginRight: "20px" }} variant="light" />;
  }
  return <div>{props.children}</div>;
};

export default Auth;
